type ClassValue = string | false | null | undefined;

/** Une clases condicionales sin arrastrar una dependencia para esto. */
export function cn(...values: ClassValue[]): string {
  return values.filter(Boolean).join(' ');
}
